import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__getAvailableSCData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var params,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
          _context.n = 1;
          return fetcher().get("/service-center/get-available-centers-data?".concat(params.join("&")));
        case 1:
          res = _context.v;
          return _context.a(2, res.data.data);
      }
    }, _callee);
  }));
  return function api__getAvailableSCData() {
    return _ref.apply(this, arguments);
  };
}();
export var api__getServiceCentersResults = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(filters) {
    var _res$data;
    var params, queryString, res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          params = new URLSearchParams();
          if (filters.make_id.value) {
            params.append('make_id', filters.make_id.value);
          }
          if (filters.city_id.value) {
            params.append('city_id', filters.city_id.value);
          }
          if (filters.dealership_name.value) {
            params.append('dealership_id', filters.dealership_name.value);
          }
          queryString = params.toString();
          _context2.n = 1;
          return fetcher().get("/service-center/search-result?".concat(queryString));
        case 1:
          res = _context2.v;
          if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 200)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, res.data.data);
        case 2:
          return _context2.a(2, []);
      }
    }, _callee2);
  }));
  return function api__getServiceCentersResults(_x) {
    return _ref2.apply(this, arguments);
  };
}();